import {
  AccountCircle,
  Search,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import "./Component.css";

import {
  Autocomplete,
  Badge,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers";
import {
  LocalizationProvider as LocalizationProviderPro,
  MobileDateRangePicker,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs as AdapterDayjsPro } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import dayjs from "dayjs";
import moment from "moment";
import PropTypes from "prop-types";
import { AppColors } from "../util/AppColors";

const tagStyle = {
  ".MuiAutocomplete-tag": {
    color: `${AppColors.white} !important`,
    background: "#D22B2B !important",
    fontWeight: "bold",
  },
  ".css-1qfjrom-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon": {
    color: `${AppColors.white} !important`,
  },
  ".css-1qfjrom-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon:hover": {
    color: "#E5E4E2 !important",
  },
  ".css-1orv2hh .MuiChip-deleteIcon": {
    color: `${AppColors.white} !important`,
    fontSize: 22,
  },
};

const StyledDatePicker = styled(StaticDatePicker)({
  "& .MuiPickersToolbar-root": {
    display: "none", // Hides the "Select date" section
  },
  "& .MuiDialogActions-root": { display: "none" },
});

const CustomTextField = ({
  label,
  defaultValue,
  helperText,
  placeholder,
  handleChange,
  value,
  multiline,
  maxRowsValue,
  select,
  chilran,
  fullWidth,
  password,
  showPassword,
  handleClickShowPassword,
  handleMouseDownPassword,
  iconTextField,
  disabled,
  search,
  name,
  startIcon,
  endIcon,
  inputIcon,
  type,
  variant,
  date,
  dateFormat,
  error,
  multiSelect,
  multiSelectItems,
  multipleSelect,
  tags,
  options,
  tagsDefaultValue,
  minDate,
  maxDate,
  mobileDate,
  mobileTime,
  required,
  multiSelectValue,
  rows,
  is12HourFomat,
  labelTop,
  backgroundColor,
  mobileDateRange,
  searchBill,
  suffix,
  mobileDateNew,
  mobileDateWithBatch,
  markDateList,
  mandatoryField,
  textRightAlign,
  staticDate,
  prefix,
  suggetions,
}) => {
  const CustomLabel = ({ label, mandatoryField }) => (
    <div className="flex-row-ali-cen">
      <Typography className="font-medium fs14">{label}</Typography>
      {mandatoryField ? <span className="red-color ml2">*</span> : ""}
    </div>
  );

  if (suggetions) {
    const suggestionOptions = Array.isArray(options) ? options : [];
    return (
      <Autocomplete
        freeSolo
        options={value?.length >= 2 ? suggestionOptions : []}
        getOptionLabel={(option) => {
          if (option == null) return "";
          return typeof option === "string" ? option : (option?.label ?? "");
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Montserrat",
              },
              display: "flex",
              alignItems: "flex-start",
              background: backgroundColor ?? AppColors.white,
              width: fullWidth ? "100%" : "50%",
              borderRadius: 1,
            }}
          />
        )}
        size="small"
        onInputChange={(e, value) => {
          handleChange({ target: { value, name } });
        }}
        value={value}
      />
    );
  }

  if (tags) {
    return (
      <Autocomplete
        multiple
        limitTags={2}
        id="multiple-limit-tags"
        options={options}
        getOptionLabel={(option) => option?.title}
        defaultValue={tagsDefaultValue}
        value={value}
        name={name}
        fullWidth={fullWidth}
        error={error}
        sx={tagStyle}
        onChange={(event, value) => handleChange({ target: { value, name } })}
        renderInput={(params, i) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            key={i}
          />
        )}
      />
    );
  }

  if (mobileDateRange) {
    return (
      <LocalizationProviderPro dateAdapter={AdapterDayjsPro}>
        <MobileDateRangePicker
          defaultValue={[dayjs(new Date()), dayjs(new Date())]}
          onChange={handleChange}
          value={value}
          disablePast
        />
      </LocalizationProviderPro>
    );
  }

  if (mobileDate) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          closeOnSelect
          label={label}
          inputFormat={dateFormat}
          value={value}
          id="filled-required"
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          error={error}
          disabled={disabled}
          onChange={(newDate) =>
            handleChange({
              target: {
                name,
                value: newDate,
              },
            })
          }
          renderInput={(params) => (
            <>
              {labelTop ? (
                <div className="flex-row-ali-cen">
                  <Typography className="font-medium fs14">{label}</Typography>
                  {mandatoryField ? (
                    <span className="red-color ml2">*</span>
                  ) : (
                    ""
                  )}
                </div>
              ) : null}
              <TextField
                {...params}
                label={
                  label && !labelTop ? (
                    <CustomLabel
                      label={label}
                      mandatoryField={mandatoryField}
                    />
                  ) : null
                }
                fullWidth={fullWidth}
                id="filled-required"
                placeholder={placeholder}
                error={error}
                helperText={helperText}
                size="small"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Montserrat",
                  },
                  display: "flex",
                  alignItems: "flex-start",
                  background: backgroundColor ?? AppColors.white,
                  width: fullWidth ? "100%" : "50%",
                  borderRadius: 1,
                }}
              />
            </>
          )}
        />
      </LocalizationProvider>
    );
  }

  if (mobileDateWithBatch) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          closeOnSelect
          label={label}
          inputFormat={dateFormat}
          value={value}
          id="filled-required"
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          error={error}
          disabled={disabled}
          onChange={(newDate) =>
            handleChange({
              target: {
                name,
                value: newDate,
              },
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              id="filled-required"
              placeholder={placeholder}
              error={error}
              helperText={helperText}
              size="small"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Montserrat",
                },
                display: "flex",
                alignItems: "flex-start",
                background: backgroundColor ?? AppColors.white,
                width: fullWidth ? "100%" : "50%",
                borderRadius: 1,
              }}
            />
          )}
          renderDay={(day, _value, DayComponentProps) => {
            return (
              <Badge
                key={day.toString()}
                overlap="circular"
                badgeContent={
                  !DayComponentProps.outsideCurrentMonth &&
                  markDateList?.some(
                    (x) => x === moment(new Date(day)).format("YYYY-MM-DD"),
                  ) && <span class="calDot">&times;</span>
                }
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                sx={{
                  "& .MuiBadge-badge": {
                    right: "50%",
                  },
                }}
              >
                <PickersDay {...DayComponentProps} />
              </Badge>
            );
          }}
        />
      </LocalizationProvider>
    );
  }

  if (mobileDateNew) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          label={label}
          inputFormat={dateFormat}
          value={value}
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          error={error}
          disabled={disabled}
          size="small"
          onChange={(newDate) =>
            handleChange({
              target: {
                name,
                value: newDate,
              },
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
              error={error}
              helperText={helperText}
              size="small"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Montserrat",
                },
                background: backgroundColor ?? AppColors.white,
              }}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  if (mobileTime) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileTimePicker
          label={label}
          value={value}
          name={name}
          disabled={disabled}
          onChange={(newDate) =>
            handleChange({
              target: {
                name,
                value: newDate,
              },
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
              error={error}
              helperText={helperText}
              size="small"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Montserrat",
                },
                background: backgroundColor,
              }}
            />
          )}
          ampm={is12HourFomat}
        />
      </LocalizationProvider>
    );
  }

  if (staticDate) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StyledDatePicker
          label={label}
          inputFormat={dateFormat}
          value={value}
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          size="small"
          onChange={(newDate) => {
            handleChange({
              target: {
                name,
                value: newDate,
              },
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  if (date) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          label={label}
          inputFormat={dateFormat}
          value={value}
          name={name}
          minDate={minDate}
          maxDate={maxDate}
          size="small"
          onChange={(newDate) =>
            handleChange({
              target: {
                name,
                value: newDate,
              },
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth={fullWidth}
              placeholder={placeholder}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  if (search) {
    return (
      <TextField
        required={required}
        id="filled-required"
        label={label}
        defaultValue={defaultValue}
        variant="outlined"
        helperText={helperText}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        fullWidth={fullWidth}
        disabled={disabled}
        name={name}
        type={type}
        autoComplete="off"
        error={error}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        size="small"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          background: backgroundColor ?? AppColors.white,
          width: fullWidth ? "100%" : "50%",
          borderRadius: 1,
        }}
      />
    );
  }

  if (searchBill) {
    return (
      <TextField
        required={required}
        id="filled-required"
        label={label}
        defaultValue={defaultValue}
        variant="outlined"
        helperText={helperText}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        fullWidth={fullWidth}
        disabled={disabled}
        name={name}
        type={type}
        error={error}
        size="small"
        sx={{
          display: "flex",
          alignItems: "flex-start",
          background: backgroundColor ?? AppColors.white,
          width: fullWidth ? "100%" : "50%",
          borderRadius: 1,
          marginLeft: 5,

          "@media (max-width: 800px)": {
            marginLeft: 0,
          },
        }}
      />
    );
  }

  if (password) {
    return (
      <FormControl
        sx={{ width: fullWidth ? "100%" : "25ch" }}
        variant={variant}
        error={error}
      >
        {labelTop ? (
          <>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14">{label}</Typography>
              {mandatoryField ? <span className="red-color ml2">*</span> : ""}
            </div>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              value={value}
              onChange={handleChange}
              name={name}
              placeholder={placeholder}
              size="small"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword(showPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </>
        ) : (
          <>
            <InputLabel htmlFor="outlined-adornment-password">
              {label}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              value={value}
              onChange={handleChange}
              name={name}
              placeholder={placeholder}
              size="small"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword(showPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              label={label}
            />
          </>
        )}
        {error ? (
          <FormHelperText error id="accountId-error">
            {helperText}
          </FormHelperText>
        ) : null}
      </FormControl>
    );
  }

  if (iconTextField) {
    return (
      <TextField
        id="input-with-icon-textfield"
        label={label}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        variant={variant}
        fullWidth={fullWidth}
        disabled={disabled}
        name={name}
        size="small"
        onChange={handleChange}
      />
    );
  }

  if (select) {
    return (
      <TextField
        required={required}
        id="filled-required"
        label={label}
        defaultValue={defaultValue}
        select
        placeholder={placeholder}
        value={value}
        size="small"
        onChange={handleChange}
        fullWidth={fullWidth}
        disabled={disabled}
        name={name}
      >
        {chilran}
      </TextField>
    );
  }

  if (multiSelect) {
    return (
      <FormControl fullWidth={fullWidth} disabled={disabled}>
        <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple={multipleSelect}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          name={name}
          size="small"
        >
          {multiSelectItems?.length > 0 &&
            multiSelectItems?.map((name, index) => (
              <MenuItem key={name + index} value={name}>
                {name.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }

  if (multiSelectValue) {
    return (
      <FormControl fullWidth={fullWidth} disabled={disabled}>
        <InputLabel id="demo-multiple-name-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple={multipleSelect}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          name={name}
          size="small"
          defaultValue={defaultValue}
        >
          {multiSelectItems?.length > 0 &&
            multiSelectItems?.map((name, index) => (
              <MenuItem key={name + index} value={name?.value}>
                {name.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }

  if (multiline) {
    return (
      <TextField
        required={required}
        multiline
        maxRows={maxRowsValue}
        id="filled-required"
        label={label}
        sx={{
          "& .MuiInputLabel-root": {
            fontFamily: "Montserrat", // Change font style to italic
          },
        }}
        size="small"
        defaultValue={defaultValue}
        variant={variant}
        helperText={helperText}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        fullWidth={fullWidth}
        disabled={disabled}
        error={error}
        name={name}
        rows={rows}
      />
    );
  }

  if (startIcon) {
    return (
      <>
        {labelTop ? (
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14">{label}</Typography>
            {mandatoryField ? <span className="red-color ml2">*</span> : ""}
          </div>
        ) : null}
        <TextField
          type={type}
          required={required}
          id="filled-required"
          label={
            labelTop ? (
              ""
            ) : (
              <CustomLabel label={label} mandatoryField={mandatoryField} />
            )
          }
          defaultValue={defaultValue}
          variant={variant}
          helperText={helperText}
          placeholder={placeholder}
          value={value}
          name={name}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">{inputIcon}</InputAdornment>
            ),
          }}
          size="small"
          autoComplete="off"
          onChange={handleChange}
          fullWidth={fullWidth}
          error={error}
          disabled={disabled}
          InputLabelProps={{
            shrink: labelTop,
          }}
        />
      </>
    );
  }

  if (endIcon) {
    return (
      <TextField
        type={type}
        required={required}
        id="filled-required"
        label={label}
        defaultValue={defaultValue}
        variant={variant}
        helperText={helperText}
        placeholder={placeholder}
        value={value}
        name={name}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">{inputIcon}</InputAdornment>
          ),
        }}
        error={error}
        size="small"
        autoComplete="off"
        onChange={handleChange}
        fullWidth={fullWidth}
        disabled={disabled}
      />
    );
  }

  if (labelTop) {
    return (
      <>
        {labelTop ? (
          <div className="flex-row-ali-cen">
            <Typography className="font-medium fs14">{label}</Typography>
            {mandatoryField ? <span className="red-color ml2">*</span> : ""}
          </div>
        ) : null}
        <TextField
          required={required}
          id="filled-required"
          defaultValue={defaultValue}
          variant="outlined"
          helperText={helperText}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          fullWidth={fullWidth}
          disabled={disabled}
          name={name}
          type={type}
          error={error}
          size="small"
          autoComplete="off"
          InputProps={{
            startAdornment: prefix && (
              <InputAdornment position="start">{prefix}</InputAdornment>
            ),
            endAdornment: suffix && (
              <InputAdornment position="end">{suffix}</InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: labelTop,
          }}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            background: AppColors.white,
            width: fullWidth ? "100%" : "50%",
            borderRadius: 1,
          }}
        />
      </>
    );
  }

  return (
    <TextField
      required={required}
      id="filled-required"
      label={label}
      defaultValue={defaultValue}
      variant="outlined"
      helperText={helperText}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      fullWidth={fullWidth}
      disabled={disabled}
      name={name}
      type={type}
      error={error}
      size="small"
      autoComplete="off"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        background: backgroundColor ?? AppColors.white,
        width: fullWidth ? "100%" : "50%",
        borderRadius: 1,
        "& .MuiInputLabel-root": {
          fontFamily: "Montserrat", // Change font style to italic
        },
      }}
      inputProps={{
        style: { textAlign: textRightAlign ? "right" : "left" },
      }}
      InputProps={{
        startAdornment: prefix && (
          <InputAdornment position="start">{prefix}</InputAdornment>
        ),
        endAdornment: suffix && (
          <InputAdornment position="end">{suffix}</InputAdornment>
        ),
        inputProps: { min: 0 },
      }}
    />
  );
};

CustomTextField.propTypes = {
  label: PropTypes.string,
  multiline: PropTypes.bool,
  helperText: PropTypes.string,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  select: PropTypes.bool,
  maxRowsValue: PropTypes.number,
  handleChange: PropTypes.func,
  value: PropTypes.any,
  fullWidth: PropTypes.bool,
  password: PropTypes.bool,
  showPassword: PropTypes.bool,
  handleClickShowPassword: PropTypes.func,
  handleMouseDownPassword: PropTypes.func,
  iconTextField: PropTypes.bool,
  name: PropTypes.string,
  startIcon: PropTypes.bool,
  endIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  dateFormat: PropTypes.string,
  date: PropTypes.bool,
  multiSelect: PropTypes.bool,
  multiSelectItems: PropTypes.array,
  multipleSelect: PropTypes.bool,
  tagsDefaultValue: PropTypes.array,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  mobileDate: PropTypes.bool,
  multiSelectValue: PropTypes.bool,
  rows: PropTypes.number,
  is12HourFomat: PropTypes.bool,
  labelTop: PropTypes.bool,
  mobileDateRange: PropTypes.bool,
  mobileDateWithBatch: PropTypes.bool,
  markDateList: PropTypes.array,
  mandatoryField: PropTypes.bool,
  textRightAlign: PropTypes.bool,
  suggetions: PropTypes.bool,
};

CustomTextField.defaultProps = {
  label: "",
  multiline: false,
  helperText: "",
  placeholder: "",
  select: false,
  maxRowsValue: 4,
  handleChange: () => {},
  value: "",
  fullWidth: false,
  password: false,
  showPassword: false,
  handleClickShowPassword: () => {},
  handleMouseDownPassword: () => {},
  iconTextField: false,
  name: "",
  startIcon: false,
  endIcon: false,
  disabled: false,
  type: "text",
  dateFormat: "DD/MM/YYYY",
  date: false,
  multiSelect: false,
  multiSelectItems: [],
  multipleSelect: true,
  tagsDefaultValue: [],
  minDate: new Date(-315639000000),
  maxDate: null,
  mobileDate: false,
  multiSelectValue: false,
  rows: 4,
  is12HourFomat: true,
  labelTop: false,
  mobileDateRange: false,
  mobileDateWithBatch: false,
  markDateList: [],
  mandatoryField: false,
  textRightAlign: false,
  suggetions: false,
};

export default CustomTextField;
